import {
  Component,
  Input,
  Output,
  EventEmitter,
  ContentChildren,
  QueryList,
  AfterContentInit,
  ViewEncapsulation,
} from '@angular/core';
import { CdkStep, CdkStepper } from '@angular/cdk/stepper';
import { IServiceConfigStep } from '../../../../core/models/service-change-request-config-steps-forms.model';

@Component({
  selector: 'irembogov-template-configuration-stepper',
  templateUrl: './template-configuration-stepper.component.html',
  styleUrls: ['./template-configuration-stepper.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: CdkStepper,
      useExisting: TemplateConfigurationStepperComponent,
    },
  ],
})
export class TemplateConfigurationStepperComponent
  extends CdkStepper
  implements AfterContentInit
{
  @Input() configSteps: IServiceConfigStep[] = [];
  @Input() showIndexInLabel = true;

  override ngAfterContentInit() {
    super.ngAfterContentInit();
  }

  selectStepByIndex(index: number) {
    if (this.canSelectStep(index)) {
      this.selectedIndex = index;
    }
  }

  canSelectStep(index: number): boolean {
    // Allow navigation to any step in preview mode since we're just viewing
    return index >= 0 && index < this.configSteps.length;
  }
}
